import { render, staticRenderFns } from "./DashboardLayoutUser.vue?vue&type=template&id=689b9d9f"
import script from "./DashboardLayoutUser.vue?vue&type=script&lang=js"
export * from "./DashboardLayoutUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports